shadow$provide[356] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Surface:{enumerable:true, get:function() {
  return Surface;
}}});
var require$three = require("three");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
var require$_DOT__DOT__SLASH_geometry_SLASH_surfacegeometry_DOT_js = require("../geometry/surfacegeometry.js");
class Surface extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    let f;
    super(renderer, shaders, options);
    let {uniforms, material} = options;
    const {position, color, normal, mask, map, combine, linear, stpq, intUV} = options;
    if (uniforms == null) {
      uniforms = {};
    }
    if (material == null) {
      material = true;
    }
    const hasStyle = uniforms.styleColor != null;
    this.geometry = new require$_DOT__DOT__SLASH_geometry_SLASH_surfacegeometry_DOT_js.SurfaceGeometry({width:options.width, height:options.height, surfaces:options.surfaces, layers:options.layers, closedX:options.closedX, closedY:options.closedY,});
    this._adopt(uniforms);
    this._adopt(this.geometry.uniforms);
    const defs = {};
    if (options.closedX) {
      defs.SURFACE_CLOSED_X = "";
    }
    if (options.closedY) {
      defs.SURFACE_CLOSED_Y = "";
    }
    if (intUV) {
      defs.POSITION_UV_INT = "";
    }
    const factory = shaders.material();
    const v = factory.vertex;
    v.pipe(this._vertexColor(color, mask));
    v.require(this._vertexPosition(position, material, map, 2, stpq));
    if (normal) {
      v.require(normal);
      v.pipe("surface.position.normal", this.uniforms, defs);
    } else {
      if (!material) {
        v.pipe("surface.position", this.uniforms, defs);
      }
      if (material) {
        v.pipe("surface.position.shaded", this.uniforms, defs);
      }
    }
    v.pipe("project.position", this.uniforms);
    factory.fragment = f = this._fragmentColor(hasStyle, material, color, mask, map, 2, stpq, combine, linear);
    f.pipe("fragment.color", this.uniforms);
    const opts = factory.link({side:require$three.DoubleSide,});
    this.material = this._material(opts);
    const object = new require$three.Mesh(this.geometry, this.material);
    object.userData = opts;
    this._raw(object);
    this.renders = [object];
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.renders = this.geometry = this.material = null;
    return super.dispose();
  }
}

};